// extracted by mini-css-extract-plugin
export default {"share":"TrainingClassShare-module__share","body":"TrainingClassShare-module__body","user_name":"TrainingClassShare-module__user_name"};